import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class MonitoramentoLinkService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };
  constructor(private tokenService: TokenService, private http: HttpClient) { }

  getListagemLinks(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/monitoramento-link/listagem`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getLinkById(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/monitoramento-link/condicao/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getPassosByLinkId(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/monitoramento-link/listarPassos/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createLinks(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/monitoramento-link/condicao`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updateLinks(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.put(`${this.apiUrl}api/monitoramento-link/condicao`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteLink(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/monitoramento-link/condicao/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  pauserRetomarLink(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.put(`${this.apiUrl}api/monitoramento-link/condicao/pausarRetomar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createPasso(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/monitoramento-link/passo`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getPassoByIds(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/monitoramento-link/obter/passo`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updatePasso(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.put(`${this.apiUrl}api/monitoramento-link/passo`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletePasso(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/monitoramento-link/passo/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteContato(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.request('delete', `${this.apiUrl}api/monitoramento-link/contato`, {
      body: payload,
      headers: this.httpOptions.headers
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  /* CHART */
  getChartHorasEvento(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/monitoramento-link/retornaHorasComEvento`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  getChartMonitoramentoData(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/monitoramento-link/dashboardMonitor`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  /* DROPDOWNS */
  getDropdownStatusMonitoramento(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/monitoramento-link/dropDownStatusMonitoramento`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownTipoMonitoramento(): Observable<any> {
    return this.http.get(`${this.apiUrl}api/monitoramento-link/dropDownTipoMonitoramento`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownGatilhoAcao(): Observable<any> {
    return this.http.get(`${this.apiUrl}api/monitoramento-link/dropDownGatilhoAcao/passo`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownPeriodo(): Observable<any> {
    return this.http.get(`${this.apiUrl}api/monitoramento-link/dropDownPeriodo`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
